/**
 * 获取渠道用户 工具类
 *
 * @author terrfly
 * @site https://www.techpayx.vip
 * @date 2021/5/8 07:18
 */
const getChannelUserId = function () {
    return localStorage.getItem("channelUserId")
}

const setChannelUserId = function (channelUserId) {
    localStorage.setItem("channelUserId", channelUserId)
}

const getUserAuthCode = function () {
    return localStorage.getItem("userAuthCode")
}

const setUserAuthCode = function (userAuthCode) {
    if (userAuthCode) {
        localStorage.setItem("userAuthCode", userAuthCode)
    }
}

export default {
    getChannelUserId: getChannelUserId,
    setChannelUserId: setChannelUserId,
    getUserAuthCode: getUserAuthCode,
    setUserAuthCode: setUserAuthCode
}
